import { render, staticRenderFns } from "./DesignRirekisho002Edit.vue?vue&type=template&id=7d5b4b50&scoped=true"
import script from "./DesignRirekisho002Edit.vue?vue&type=script&setup=true&lang=ts"
export * from "./DesignRirekisho002Edit.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DesignRirekisho002Edit.vue?vue&type=style&index=0&id=7d5b4b50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d5b4b50",
  null
  
)

export default component.exports